// import React, { useState, useEffect } from "react";
// import { loadStripe } from "@stripe/stripe-js";
// import { Elements } from "@stripe/react-stripe-js";

// import CheckoutForm from "./checkout_form";
// const stripePromise = loadStripe("pk_test_51Jn2DuKWdkJ2JQMunZURgr2YQPSCUu4SGAhGsbEVvrhqzwDfjGPFHn5xjJbD5w79Ud0c1xpUdvZBx5gSOm906Uge00UeF51YVx");

// export default function StripeCheckout() {
//   const [clientSecret, setClientSecret] = useState("");

//   useEffect(() => {
//     // replace this with your own server endpoint
//     fetch("http://192.168.29.2:8000/api/v1/subscription/create-payment-intent", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ items: [{ id: "xl-tshirt" }] }),
//     })
//       .then((res) => {
//         if (!res.ok) {
//           throw new Error("Network response was not ok");
//         }
//         return res.json();
//       })
//       .then((data) => setClientSecret(data.clientSecret))
//       .catch((error) => {
//         console.log(error);
//       });
//   }, []);
//   const appearance = {
//     theme: 'stripe',
//   };
//   const options = {
//     clientSecret,
//     appearance
//   };

//   return (
//     <div>
//       {clientSecret && (
//         <Elements options={options} stripe={stripePromise}>
//           <CheckoutForm />
//         </Elements>
//       )}
//     </div>
//   );
// }

import React ,{ useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { useLocation } from "react-router-dom";
import { UseSelector, useSelector } from "react-redux/es/hooks/useSelector";
// import CheckoutForm from "./CheckoutForm";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./checkout_form"
import Head from "../Header/head";
import "../../common/fonts/fonts.css";
import "../auth/login.css";
import "./subscription.css";

function Payment() {
  const [stripePromise, setStripePromise] = useState("");
  const [clientSecret, setClientSecret] = useState(false);
  const location = useLocation();
  const type = location.state.plan_type;
  const auth = useSelector((state)=>state.jwtAuthreducer)
  // console.log(type,"from checkout =========")
  useEffect(() => {
    var publishableKey = process.env.REACT_APP_STRIP_PUBLISH_KEY
    setStripePromise(loadStripe(publishableKey));
    
    return ()=>{
      fetch(`${process.env.REACT_APP_BASE_BACKEND_API_URL}/subscription/create-payment-intent`, {
      method: "POST",
      headers: {
        "Authorization":` Bearer ${localStorage.getItem("accessToken")}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({type:type}),
    }).then(async (result) => {
      var { client_secret } = await result.json();
      setClientSecret(client_secret);
    });
    }
    
    // fetch("/config").then(async (r) => {
    //   const { publishableKey } = await r.json();
    
    // });
  }, []);


  return (
    <>
     {clientSecret  && (
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <CheckoutForm />
          </Elements>
      )}
     
     
    </>
  );
}

export default Payment;
